<template>
  <!-- 机构管理页 -->
  <div class="layout">
    <div class="menu">
      <Menu topIndex="dept"></Menu>
    </div>
    <div class="leftSideBar">
      <LeftSideBar current="dept" leftIndex="dept"></LeftSideBar>
    </div>
    <div id="deptContentBox" class="base-content">
      <!-- 上方按钮 -->
      <div>
        <el-button
          type="text"
          size="small"
          icon="el-icon-plus"
          @click="firstCreate()"
          >新增</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-edit"
          @click="preCheck('toEdit')"
          >修改</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-close"
          @click="preCheck('toDelete')"
          >删除</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-refresh"
          @click="preCheck('toAPI')"
          >API授权新增</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-refresh"
          @click="preCheck('toEditAPI')"
          >API授权编辑</el-button
        >
      </div>
      <!-- 显示列表 -->
      <el-table
        class="mainTableList"
        :data="institutionTableData"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        style="width: 100%"
        border
        :header-cell-style="{ background: '#f8f8f8' }"
        @selection-change="handleTableSelectionChange"
      >
        <el-table-column
          type="selection"
          min-width="55"
          align="center"
        ></el-table-column>
        <el-table-column type="index" min-width="50" align="center">
        </el-table-column>
        <el-table-column
          prop="deptName"
          show-overflow-tooltip
          min-width="80"
          label="机构名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="addUser"
          min-width="80"
          label="录入人"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="status"
          show-overflow-tooltip
          label="机构状态"
          min-width="70px"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag type="info" effect="dark" v-if="scope.row.status == 10"
              >停用</el-tag
            >
            <el-tag type="success" effect="dark" v-if="scope.row.status == 20"
              >启用</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="API授权信息"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              style="display: block; text-align: center; margin: 0 auto"
              :disabled="scope.row.tokenInfo == null"
              @click="viewAPI(scope.row)"
              >【查看】</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="phone"
          show-overflow-tooltip
          label="手机号码"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="linkUser"
          show-overflow-tooltip
          label="联系人"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="description"
          show-overflow-tooltip
          label="机构描述"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="addTime"
          show-overflow-tooltip
          label="录入时间"
          align="center"
        >
        </el-table-column>
        <el-table-column show-overflow-tooltip label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              class="createSubLib"
              style="
                display: block;
                text-align: center;
                margin: 0 auto;
                padding: 2px 0;
              "
              :disabled="scope.row.tokenInfo == null"
              @click="createSubLib(scope)"
              >{{ subLibBtnText }}</el-button
            >
            <el-button
              type="text"
              style="
                display: block;
                text-align: center;
                margin: 0 auto;
                padding: 2px 0;
              "
              :disabled="scope.row.tokenInfo == null"
              @click="syncSubToken(scope.row)"
              >【同步token】</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 新增机构弹窗 -->
    <el-dialog
      title="新增机构"
      :visible.sync="createDialog"
      width="600px"
      @open="noClick = false"
    >
      <el-form
        ref="addInstituteForm"
        :rules="addInstituteRules"
        :model="addInstituteForm"
      >
        <el-form-item label="机构名称" label-width="80px" prop="deptName">
          <el-input
            v-model="addInstituteForm.deptName"
            placeholder="请输入机构名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="机构状态" label-width="80px">
          <el-select v-model="addInstituteForm.status" clearable>
            <el-option
              v-for="item in statusList"
              :key="item.code"
              :value="item.value"
              :label="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号码" label-width="80px" prop="phone">
          <el-input
            v-model="addInstituteForm.phone"
            placeholder="请输入手机号码"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人" label-width="80px">
          <el-input
            v-model="addInstituteForm.linkUser"
            placeholder="请输入联系人"
          ></el-input>
        </el-form-item>
        <el-form-item label="机构描述" label-width="80px">
          <el-input
            v-model="addInstituteForm.description"
            placeholder="请输入机构描述"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createInstitute('addInstituteForm')"
          >确 定
        </el-button>
        <el-button @click="createDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 编辑机构弹窗 -->
    <el-dialog
      title="编辑组织机构"
      :visible.sync="editDialog"
      width="600px"
      center
    >
      <el-form
        ref="editInstituteForm"
        :rules="editInstituteRules"
        :model="editInstituteForm"
        label-width="80px"
      >
        <el-form-item label="机构名称" prop="orgName">
          <el-input
            v-model="editInstituteForm.deptName"
            placeholder="请输入机构名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="机构状态" label-width="80px">
          <el-select v-model="editInstituteForm.status" clearable>
            <el-option
              v-for="item in statusList"
              :key="item.code"
              :value="item.value"
              :label="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号码" label-width="80px" prop="phone">
          <el-input
            v-model="editInstituteForm.phone"
            placeholder="请输入手机号码"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人" label-width="80px">
          <el-input
            v-model="editInstituteForm.linkUser"
            placeholder="请输入联系人"
          ></el-input>
        </el-form-item>
        <el-form-item label="机构描述" label-width="80px">
          <el-input
            v-model="editInstituteForm.description"
            placeholder="请输入机构描述"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateInstitute('editInstituteForm')"
          >确 定
        </el-button>
        <el-button @click="editDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 删除机构弹窗 -->
    <el-dialog title="删除机构" :visible.sync="deleteDialog" width="30%" center>
      <div>确定删除该组织机构？</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onDelete">确 定</el-button>
        <el-button @click="deleteDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- API授权新增弹窗 -->
    <el-dialog title="API授权" :visible.sync="addAPIDialog" width="600px">
      <el-form ref="addAPIForm" :rules="addAPIRules" :model="addAPIForm">
        <el-form-item label="ip：" label-width="130px" prop="ip">
          <el-input
            type="textarea"
            v-model="addAPIForm.ip"
            placeholder="请输入ip"
          ></el-input>
          <p
            style="
              margin-bottom: 0;
              font-size: 12px;
              line-height: 1.5em;
              color: red;
            "
          >
            * 多个ip请用逗号隔开
          </p>
        </el-form-item>

        <el-form-item label="计费方式：" label-width="130px" prop="type">
          <el-select v-model="addAPIForm.type" clearable>
            <el-option value="10" label="次数计费"> </el-option>
            <el-option value="20" label="字符计费（1000字符/元）"> </el-option
            ><el-option value="30" label="截止时间"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类目录：" label-width="130px" prop="innerCodes">
          <el-select v-model="selectedName" multiple collapse-tags>
            <el-option :value="dataList"
              ><el-tree
                ref="tree"
                :props="props"
                :load="loadNode"
                check-on-click-node
                highlight-current
                :expand-on-click-node="false"
                show-checkbox
                @check-change="handleCheckChange"
                node-key="innerCode"
                check-strictly
                lazy
              >
              </el-tree>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="单价："
          label-width="130px"
          prop="price"
          :required="addAPIForm.type == 10 || addAPIForm.type == 20"
        >
          <el-input
            v-model="addAPIForm.price"
            placeholder="请输入单价"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="余额："
          label-width="130px"
          prop="balance"
          :required="addAPIForm.type == 10"
        >
          <el-input
            v-model="addAPIForm.balance"
            placeholder="请输入余额"
          ></el-input>
        </el-form-item>
        <el-form-item label="标签：" label-width="130px">
          <el-select
            v-model="tagInfo"
            multiple
            collapse-tags
            placeholder="请选择标签"
          >
            <el-option
              v-for="(item, index) in tagInfoList"
              :key="index"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="截止时间：" label-width="130px" prop="endTime">
          <el-date-picker
            v-model="addAPIForm.endTime"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="是否允许重复：" label-width="130px">
          <el-select v-model="addAPIForm.isRepeat" clearable>
            <el-option value="10" label="否"> </el-option>
            <el-option value="20" label="是"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="子库地址：" label-width="130px">
          <el-input
            v-model="addAPIForm.url"
            placeholder="请输入子库地址"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createapi('addAPIForm')"
          >确 定
        </el-button>
        <el-button @click="addAPIDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- API授权编辑弹窗 -->
    <el-dialog
      title="API授权信息编辑"
      :visible.sync="editAPIDialog"
      width="600px"
    >
      <el-form ref="editAPIForm" :rules="addAPIRules" :model="editAPIForm">
        <el-form-item label="ip：" label-width="130px" prop="ip">
          <el-input
            type="textarea"
            v-model="editAPIForm.ip"
            placeholder="请输入ip"
          ></el-input>
          <p
            style="
              margin-bottom: 0;
              font-size: 12px;
              line-height: 1.5em;
              color: red;
            "
          >
            * 多个ip请用逗号隔开
          </p>
        </el-form-item>
        <el-form-item label="单价：" label-width="130px" prop="price">
          <el-input
            v-model="editAPIForm.price"
            placeholder="请输入单价"
          ></el-input>
        </el-form-item>
        <el-form-item label="余额：" label-width="130px" prop="balance">
          <el-input
            v-model="editAPIForm.balance"
            placeholder="请输入余额"
          ></el-input>
        </el-form-item>
        <el-form-item label="机构ID：" label-width="130px">
          <el-input v-model="editAPIForm.deptId" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="分类目录：" label-width="130px" prop="innerCodes">
          <el-select v-model="selectedName" multiple collapse-tags>
            <el-option :value="dataList"
              ><el-tree
                v-if="openTree"
                ref="editTree"
                :props="props"
                :load="loadNode"
                check-on-click-node
                highlight-current
                :expand-on-click-node="false"
                show-checkbox
                @check-change="handleCheckChange2"
                node-key="innerCode"
                :default-checked-keys="selectedValue"
                check-strictly
                lazy
              >
              </el-tree>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标签：" label-width="130px">
          <el-select
            v-model="tagInfoEdit"
            multiple
            collapse-tags
            placeholder="请选择标签"
          >
            <el-option
              v-for="(item, index) in tagInfoList"
              :key="index"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="截止时间：" label-width="130px" prop="endTime">
          <el-date-picker
            v-model="editAPIForm.endTime"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="是否允许重复：" label-width="130px">
          <el-select v-model="editAPIForm.isRepeat" clearable>
            <el-option value="10" label="否"> </el-option>
            <el-option value="20" label="是"> </el-option>
          </el-select> </el-form-item
        ><el-form-item label="计费方式：" label-width="130px">
          <el-select v-model="editAPIForm.type" clearable>
            <el-option value="10" label="次数计费"> </el-option>
            <el-option value="20" label="字符计费（1000字符/元）"> </el-option
            ><el-option value="30" label="截止时间"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="子库地址：" label-width="130px">
          <el-input
            v-model="editAPIForm.url"
            placeholder="请输入子库地址"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="checkEditAPI('editAPIForm')"
          >确 定
        </el-button>
        <el-button @click="editAPIDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- API授权查看弹窗 -->
    <el-dialog title="API授权信息" :visible.sync="viewAPIDialog" width="600px">
      <div class="apiList">
        <p><span>授权码：</span>{{ apiListData.token }}</p>
        <p><span>IP：</span>{{ apiListData.ip }}</p>
        <p><span>单价：</span>{{ apiListData.price }}</p>
        <p><span>余额：</span>{{ apiListData.balance }}</p>
        <p>
          <span>是否允许重复：</span>
          <span v-if="apiListData.isRepeat == 20" style="font-weight: normal"
            >是</span
          >
          <span v-if="apiListData.isRepeat == 10" style="font-weight: normal"
            >否</span
          >
        </p>
        <p>
          <span>计费方式：</span>
          <span v-if="apiListData.type == 10" style="font-weight: normal"
            >次数计费</span
          >
          <span v-if="apiListData.type == 20" style="font-weight: normal"
            >字符计费（1000字符/元）</span
          >
          <span v-if="apiListData.type == 30" style="font-weight: normal"
            >截止时间</span
          >
        </p>
        <p>
          <span>标签：</span>
          <span
            v-for="item in apiListData.tagInfos"
            :key="item.id"
            class="showTag"
            >{{ item.classify }}</span
          >
        </p>
        <p>
          <span>分类目录：</span>
          <el-table
            :data="apiListData.subjectInfos"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            style="width: 100%"
            border
            :header-cell-style="{ background: '#f8f8f8' }"
          >
            <el-table-column
              prop="name"
              show-overflow-tooltip
              label="分类名称"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="subBranch"
              show-overflow-tooltip
              label="分类路径"
              align="center"
            ></el-table-column>
          </el-table>
        </p>
        <p><span>截止时间：</span>{{ apiListData.endTime }}</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Menu from "../menu/menu.vue";
import LeftSideBar from "../menu/leftSideBar.vue";
import $ from "jquery";
import cookies from "vue-cookies";
export default {
  components: {
    Menu,
    LeftSideBar,
  },
  data() {
    // 添加机构电话验证
    var validateTelAdd = (rule, value, callback) => {
      if (value === "" || value == undefined) {
        callback();
      } else {
        if (
          (this.addInstituteForm.phone &&
            this.addInstituteForm.phone.toString().indexOf("-") !== -1) ||
          /^1[3456789]\d{9}$/.test(this.addInstituteForm.phone)
        ) {
          callback();
        }
        callback(new Error("请输入正确的电话格式"));
      }
    };
    // 修改机构电话验证
    var validateTelEdit = (rule, value, callback) => {
      if (value === "" || value == undefined) {
        callback();
      } else {
        if (
          (this.editInstituteForm.phone &&
            this.editInstituteForm.phone.toString().indexOf("-") !== -1) ||
          /^1[3456789]\d{9}$/.test(this.editInstituteForm.phone)
        ) {
          callback();
        }
        callback(new Error("请输入正确的电话格式"));
      }
    };
    // 添加API授权ip验证
    var validateIPAdd = (rule, value, callback) => {
      if (value === "" || value == undefined ||value === null) {
        callback();
      } else {
        let ipArry = value.split(",");
        let flagArr = [];
        let flag;
        $.each(ipArry, function (index, element) {
          if (element.indexOf("-") !== -1) {
            var isValid =
              /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}-(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/.test(
                element
              );
            if (isValid) {
              flagArr.push(true);
            } else {
              flagArr.push(false);
            }
          } else {
            let voidChar =
              /^((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))$/g;
            if (voidChar.test(element)) {
              flagArr.push(true);
            } else {
              flagArr.push(false);
            }
          }
        });
        flag = flagArr.every(function (value) {
          return value;
        });
        if (flag) {
          callback();
        } else {
          callback(new Error("请输入正确的IP格式"));
        }
      }
    };
    return {
      current: "dept",
      subLibBtnText: "【生成子库数据】",
      tagInfoList: [],
      tagInfo: [],
      tagInfoEdit: [],
      openTree:true,
      multipleSelectionTable: [],
      deptId: "", //授权专用
      addInstituteForm: {
        deptName: "",
        linkUser: "",
        description: "",
        status: "",
        phone: "",
      },
      editInstituteForm: {
        id: "",
        deptName: "",
        linkUser: "",
        description: "",
        status: "",
        phone: "",
      },
      addAPIForm: {
        ip: "",
        price: "",
        balance: "",
        deptId: "",
        innerCodes: "",
        endTime: "",
        isRepeat: "",
        type: "",
      },
      editAPIForm: {
        id: "",
        ip: "",
        price: "",
        balance: "",
        deptId: "",
        innerCodes: "",
        endTime: "",
        isRepeat: "",
        type: "",
      },
      statusList: [
        {
          label: "停用",
          value: 10,
        },
        {
          label: "启用",
          value: 20,
        },
      ],
      listData: [],
      currentPage: 1,
      pageSize: 10,
      totalSize: 50,
      dataText: "",
      optionData: [],
      dataList: [],
      codeArr: [],
      apiListData: [],
      selectedValue: [],
      selectedName: [],
      institutionTableData: [],
      createDialog: false,
      addAPIDialog: false,
      editDialog: false,
      deleteDialog: false,
      editAPIDialog: false,
      viewAPIDialog: false,
      addInstituteRules: {
        deptName: [
          { required: true, message: "请输入机构名称", trigger: "blur" },
        ],
        phone: [{ validator: validateTelAdd, trigger: "blur" }],
      },
      editInstituteRules: {
        deptName: [
          { required: true, message: "请输入机构名称", trigger: "blur" },
        ],
        phone: [{ validator: validateTelEdit, trigger: "blur" }],
      },
      addAPIRules: {
        ip: [
          {
            validator: validateIPAdd,
            trigger: "blur",
          },
        ],
        innerCodes: [
          { required: true, message: "请选择分类目录", trigger: "blur" },
        ],
        endTime: [{ message: "请输入截止时间", trigger: "blur" }],
        type: [{ required: true, message: "请输入截止时间", trigger: "blur" }],
      },
      props: {
        label: "name",
        children: "children",
        isLeaf: "leaf",
      },
    };
  },
  mounted() {
    var that = this;
    if (cookies.get("username") == "管理员") {
      this.dataText = "暂无权限";
    }
    // 统一验证token
    var currentToken = cookies.get("token");
    $.ajaxSetup({
      headers: {
        AuthorizationToken: currentToken,
      },
      complete: function (xhr) {
        if (xhr.responseJSON.code == 401) {
          window.location.href = "/";
        }
      },
    });
    $.ajax({
      url: "/zyk/c/tag/tagInfo/list",
      type: "GET",
      //contentType: 'application/json;charset=utf-8',
      data: {
        page: 1,
        size: 1000,
      },
      dataType: "json",
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.reload();
        }
      },
      success: function (data) {
        var tagData = data.obj.list;
        for (var i = 0; i < tagData.length; i++) {
          that.tagInfoList.push({
            name: tagData[i].classify,
            value: tagData[i].id,
          });
        }
      },
    });
    this.searchParam();
  },
  methods: {
    // 显示新增弹框
    firstCreate() {
      this.createDialog = true;
      // if (this.pageAuth.s || this.isadmin) {
      //   this.searchTreeData();
      // }
      // 组织机构树开始
      // this.SelectvalueTitle = "";
      // 组织机构树结束
      this.addInstituteForm = {
        deptName: "",
        linkUser: "",
        description: "",
        status: "",
        phone: "",
      };
    },

    // 加载数据
    searchParam() {
      let that = this;
      let params = {};
      params.size = this.pageSize;
      params.page = this.currentPage;
      $.ajax({
        type: "GET",
        dataType: "json",
        url: "/zyk/auth/deptInfo/treeList",
        data: params,
        contentType: "application/json;charset=utf-8",
        success: function (response) {
          if (response.code == 200) {
            that.optionData = response.obj.list;
            if (response.obj && response.obj.total == 0) {
              that.dataText = "暂无数据";
            }
            that.totalSize = response.obj.total;
            that.institutionTableData = response.obj.list;
            that.currentPage = response.obj.pageNum;
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    // 新增组织机构
    createInstitute(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //     if (this.addInstituteForm.parentId) {
          //       delete this.addInstituteForm.webUrl;
          //     }
          let that = this;
          //     that.noClick = true;
          $.ajax({
            url: "/zyk/c/auth/deptInfo/add",
            type: "POST",
            dataType: "json",
            data: this.addInstituteForm,
            error: function (xhr) {
              if (xhr.status == 401) {
                window.location.reload();
              }
            },
            success: function (data) {
              if (data.code == 200) {
                that.$message({
                  message: "新增成功",
                  duration: 2000,
                  showClose: true,
                  type: "success",
                  offset: 100,
                });
                that.searchParam();
                that.createDialog = false;
              } else {
                that.$message({
                  message: data.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                  onClose: function () {
                    // that.noClick = false;
                  },
                });
              }
            },
          });
          //   } else {
          //     console.log("error submit!!");
          //     return false;
          //    }
        }
      });
    },
    // 编辑
    editInstitute(row) {
      this.editInstituteForm = {
        id: row[0].id,
        deptName: row[0].deptName,
        linkUser: row[0].linkUser,
        description: row[0].description,
        status: row[0].status,
        phone: row[0].phone,
      };
      this.editDialog = true;
    },
    // 确认修改
    updateInstitute(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          // that.noClick = true;
          $.ajax({
            url: "/zyk/c/auth/deptInfo/update",
            type: "POST",
            dataType: "json",
            data: that.editInstituteForm,
            error: function (xhr) {
              if (xhr.status == 401) {
                window.location.reload();
              }
            },
            success: function (data) {
              if (data.code == 200) {
                that.$message({
                  message: "修改成功",
                  duration: 2000,
                  showClose: true,
                  type: "success",
                  offset: 100,
                });
                that.searchParam();
                that.editDialog = false;
              } else {
                that.$message({
                  message: data.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                  onClose: function () {
                    that.noClick = false;
                  },
                });
              }
            },
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 编辑、删除、转正式前确认
    preCheck(current) {
      if (this.multipleSelectionTable.length == 0) {
        this.$message({
          message: "请选中具体的组织机构",
          duration: 0,
          showClose: true,
          type: "error",
          offset: 100,
        });
      } else if (current == "toEdit") {
        // 编辑确认
        if (this.multipleSelectionTable.length == 1) {
          this.editInstitute(this.multipleSelectionTable);
        } else {
          this.$message({
            message: "请勿选择多个进行编辑",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        }
      } else if (current == "toDelete") {
        // 删除确认
        let flag = this.multipleSelectionTable.every(function (value) {
          if (value.status == 10) {
            return true;
          }
        });
        if (flag) {
          this.deleteDialog = true;
        } else {
          this.$message({
            message: "当前机构非停用状态，请停用后再进行删除操作",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        }
      } else if (current == "toAPI") {
        // api新增确认
        if (this.multipleSelectionTable.length == 1) {
          if (this.multipleSelectionTable[0].tokenInfo != null) {
            this.$message({
              message: "当前机构已添加过授权，如需修改请点击“API授权编辑按钮”",
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          } else {
            this.firstAPICreate(this.multipleSelectionTable[0].id);
          }
        } else {
          this.$message({
            message: "请勿选择多个进行授权",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        }
      } else if (current == "toEditAPI") {
        // api新增确认
        if (this.multipleSelectionTable.length == 1) {
          if (this.multipleSelectionTable[0].tokenInfo == null) {
            this.$message({
              message: "当前机构还未进行授权，请授权后再进行修改",
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          } else {
            this.editAPI(this.multipleSelectionTable[0]);
          }
        } else {
          this.$message({
            message: "请勿选择多个进行编辑",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        }
      }
    },
    // 删除
    onDelete() {
      let ids = this.multipleSelectionTable.map((item) => {
        return item.id;
      });
      let that = this;
      // that.noClick = true;
      $.ajax({
        url: "/zyk/c/auth/deptInfo/remove",
        type: "POST",
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        data: { ids: ids.toString() },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (data.code == 200) {
            that.$message({
              message: "删除成功",
              duration: 2000,
              showClose: true,
              type: "success",
              offset: 100,
            });
            that.searchParam();
            that.deleteDialog = false;
          } else {
            that.$message({
              message: data.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
              onClose: function () {
                // that.noClick = false;
              },
            });
          }
        },
      });
    },
    // 显示新增api弹框
    firstAPICreate(deptId) {
      var that = this;
      this.addAPIDialog = true;
      that.selectedValue = [];
      that.selectedName = [];
      that.tagInfo = [];
      this.addAPIForm = {
        ip: "",
        price: "",
        balance: "",
        deptId: deptId,
        innerCodes: "",
        endTime: "",
      };
    },
    // api授权
    createapi(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          this.addAPIForm.tagIds = this.tagInfo.toString();
          $.ajax({
            url: "/zyk/c/token/tokenInfo/add",
            type: "POST",
            dataType: "json",
            data: this.addAPIForm,
            error: function (xhr) {
              if (xhr.status == 401) {
                window.location.reload();
              }
            },
            success: function (data) {
              if (data.code == 200) {
                that.$message({
                  message: "新增成功",
                  duration: 2000,
                  showClose: true,
                  type: "success",
                  offset: 100,
                });
                that.searchParam();
                that.addAPIDialog = false;
              } else {
                that.$message({
                  message: data.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                });
              }
            },
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //api编辑确认
    checkEditAPI(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          this.editAPIForm.tagIds = that.tagInfoEdit.toString();
          let innerCodes = that.editAPIForm.innerCodes;

          if (innerCodes.startsWith(",")) {
            innerCodes = innerCodes.substring(1);
          }

          if(innerCodes.endsWith(",")) {
            innerCodes = innerCodes.substring(0,innerCodes.length-1)
          }

          this.editAPIForm.innerCodes = innerCodes

          $.ajax({
            url: "/zyk/c/token/tokenInfo/update",
            type: "POST",
            dataType: "json",
            data: this.editAPIForm,
            error: function (xhr) {
              if (xhr.status == 401) {
                window.location.reload();
              }
            },
            success: function (data) {
              if (data.code == 200) {
                that.$message({
                  message: "编辑成功",
                  duration: 2000,
                  showClose: true,
                  type: "success",
                  offset: 100,
                });
                that.searchParam();
                that.editAPIDialog = false;
              } else {
                that.$message({
                  message: data.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                });
              }
            },
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 查看api信息
    viewAPI(row) {
      console.log(row);
      let that = this;
      that.apiListData = row.tokenInfo;
      console.log(that.apiListData);
      this.viewAPIDialog = true;
    },
    // 生成子库数据
    createSubLib(scope) {
      $(".createSubLib")
        .eq(scope.$index)
        .text("【子库数据生成中……】")
        .prop("disabled", true)
        .addClass("createSubLibing");
      var that = this;
      var downloadA = document.createElement("a");
      $.ajax({
        type: "POST",
        dataType: "json",
        url: "/zyk/token/createSubLib",
        data: { id: scope.row.tokenId },
        // contentType: "application/json;charset=utf-8",
        success: function (response) {
          if (response.code == 200) {
            downloadA.href = response.obj.url;
            downloadA.download;
            downloadA.click();
            $(".createSubLib")
              .eq(scope.$index)
              .text("【生成子库数据】")
              .prop("disabled", false)
              .removeClass("createSubLibing");
            that.$message({
              message: "子库数据已生成",
              duration: 0,
              showClose: true,
              type: "success",
              offset: 100,
            });
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },

    // 同步token
    syncSubToken(row) {
      var that = this;
      $.ajax({
        type: "POST",
        dataType: "json",
        url: "/zyk/token/syncSubToken",
        data: { tokenId: row.tokenId },
        // contentType: "application/json;charset=utf-8",
        success: function (response) {
          if (response.code == 200) {
            that.$message({
              message: "同步token已完成",
              duration: 0,
              showClose: true,
              type: "success",
              offset: 100,
            });
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },

    // 树形结构加载
    loadNode(node, resolve) {
      let that = this;
      this.getAuthority = node;
      $.ajax({
        url: "/zyk/c/subject/subjectInfo/list?page=1&size=1000",
        type: "GET",
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (node.level == 0) {
            this.treeNode_had = node;
            that.dataList = data.obj.list;
            return resolve(that.dataList);
          } else {
            $.ajax({
              url: "/zyk/c/subject/subjectInfo/list?page=1&size=1000",
              type: "GET",
              //contentType: 'application/json;charset=utf-8',
              data: { id: node.data.id },
              dataType: "json",
              error: function (xhr) {
                if (xhr.status == 401) {
                  window.location.reload();
                }
              },
              success: function (data) {
                return resolve(data.obj.list);
              },
            });
          }
        },
      });
    },
    handleCheckChange() {
      let that = this;
      this.selectedName = this.$refs.tree.getCheckedNodes().map((item) => {
        return item.name;
      });
      that.addAPIForm.innerCodes = this.$refs.tree.getCheckedKeys().toString();
    },
    handleCheckChange2(node) {
      // let that = this;
      
      let currentInnerCode = node.innerCode; // 当前节点的内部编码
      let checkedKeys = this.$refs.editTree.getCheckedKeys(); // 获取所有选中的节点的key

      var index = checkedKeys.indexOf(currentInnerCode);
      if (index > -1) {
        if (this.editAPIForm.innerCodes.endsWith(",")) {
          this.editAPIForm.innerCodes += currentInnerCode +",";
        }else{
          this.editAPIForm.innerCodes += "," + currentInnerCode +",";
        }
        
      }else{
        this.editAPIForm.innerCodes = this.editAPIForm.innerCodes.replace(","+currentInnerCode+",",",");
      }

      this.selectedName = this.$refs.editTree.getCheckedNodes().map((item) => {
        return item.name;
      });
      // this.editAPIForm.innerCodes = this.editAPIForm.innerCodes + this.$refs.editTree
      //   .getCheckedKeys()
      //   .toString();
    },
    // 获取所有的treeids
    getAllNodeIds(treeData) {
      let ids = [];
      function traverse(nodes) {
        nodes.forEach(node => {
          ids.push(node.innerCode);
        });
      }
      traverse(treeData);
      return ids;
    },
    // api信息编辑
    editAPI(row) {
      var that = this;
      that.selectedValue=[];
      that.selectedName = [];
      that.tagInfoEdit = [];
      
      this.openTree = false;
      this.$nextTick(() => {
        this.openTree = true;
      });
      this.editAPIForm = {
        id: row.tokenInfo.id,
        ip: row.tokenInfo.ip,
        price: row.tokenInfo.price,
        balance: row.tokenInfo.balance,
        deptId: row.id,
        innerCodes: ","+row.tokenInfo.innerCodes+",",

        endTime: row.tokenInfo.endTime,
        // isRepeat: row.tokenInfo.isRepeat.toString(),
        // type: row.tokenInfo.type.toString(),
        tagIds: row.tokenInfo.tagIds,
      };
      if(row.tokenInfo.isRepeat){
        this.editAPIForm.isRepeat = row.tokenInfo.isRepeat.toString()
      }
      if(row.tokenInfo.type){
        this.editAPIForm.type = row.tokenInfo.type.toString()
      }
      that.selectedValue = row.tokenInfo.innerCodes.split(",");
      that.selectedName = row.tokenInfo.subjectInfos.map((item) => {
        return item.name;
      });

      if (row.tokenInfo.tagIds != null) {
        for (var i = 0; i < row.tokenInfo.tagIds.split(",").length; i++) {
          that.tagInfoEdit.push(Number(row.tokenInfo.tagIds.split(",")[i]));
        }
      }
      if (this.treeNode_had) {
        this.treeNode_had.childNodes = [] // 清空子节点
        this.loadNode(this.treeNode_had, this.resolve_had) // 再次执行 load 的方法
      }
      this.editAPIDialog = true;
    },
    // 选择表格某一行
    handleTableSelectionChange(val) {
      this.multipleSelectionTable = val;
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.searchParam();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchParam();
    },
  },
};
</script>

<style>
.apiList p {
  font-size: 16px;
  line-height: 2.5em;
}
.apiList p span {
  font-weight: bolder;
}

.apiList p .showTag {
  padding: 5px 15px;
  margin-left: 10px;
  background-color: rgba(102, 102, 102, 0.1);
  border-radius: 10px;
  font-weight: normal;
}

.mainTableList .el-button--text:focus,
.mainTableList .el-button--text {
  color: #50b58d !important;
}
.mainTableList .el-button.is-disabled,
.mainTableList .el-button.is-disabled:focus,
.mainTableList .el-button.is-disabled:hover {
  color: #c0c4cc !important;
}

.createSubLib.createSubLibing {
  color: #c0c4cc !important;
  cursor: not-allowed !important;
}
</style>